export const STATUS_MAP = {
  created: { label: 'Sent', color: 'primary' },
  sent: { label: 'Sent', color: 'primary' },
  in_progress: { label: 'In progress', color: 'warning' },
  waiting_for_results: { label: 'Waiting results', color: 'warning' },
  processing: { label: 'Waiting results', color: 'warning' },
  completed: {
    label: 'Completed',
    color: 'success',
    tooltip: true,
    iconColor: 'proxify-success-500',
  },
  canceled: { label: 'Canceled', color: 'gray' },
  expired: { label: 'Expired', color: 'dark' },
  deleted: { label: 'Deleted', color: 'gray' },
  failed: {
    label: 'Failed',
    color: 'error',
    tooltip: true,
    iconColor: 'proxify-error-500',
  },
};

export const INTEGRITY_RISK_STATUS_MAP = {
  no_risk: {
    label: 'No risk',
    color: 'success',
  },
  low: {
    label: 'Low',
    color: 'primary',
  },
  moderate: {
    label: 'Moderate',
    color: 'warning',
  },
  high: {
    label: 'High',
    color: 'error',
  },
};
